<template>
  <div v-if="store.state.role === 'admin'" class="wrapper">
    <el-button
      :loading="loading"
      class="upload-demo"
      type="success"
      style="margin-right: 10px"
      @click="downloadAllAsExcel"
    >
      <img
        style="margin-right: 10px"
        alt=""
        src="@/assets/images/icons/download.svg"
      />
      Mavjud ID larni yuklab olish
    </el-button>
    <el-button
      :loading="loading"
      class="upload-demo"
      type="success"
      style="margin-right: 10px"
      @click="isModalOpen = true"
    >
      <img
        style="margin-right: 10px"
        alt=""
        src="@/assets/images/icons/edit.svg"
      />
      ID larni ozgartirish
    </el-button>
    <el-upload
      ref="uploadRef"
      class="upload-demo"
      :http-request="customUpload"
      :multiple="false"
      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
      :limit="1"
      :on-error="onErrorUpload"
      :before-upload="beforeUpload"
    >
      <template #trigger>
        <el-button style="width: 100%" type="primary" :loading="loading">
          ID larni ozgartirish (fayl orqali)
        </el-button>
      </template>
    </el-upload>
  </div>

  <el-dialog
    v-model="isModalOpen"
    :title="
      modalStep === 'input'
        ? 'Invest ID kiriting'
        : 'Invest ma\'lumotlarini tahrirlash'
    "
    :width="modalStep === 'input' ? '400px' : '600px'"
    @close="resetForm"
  >
    <!-- Input step -->
    <div v-if="modalStep === 'input'">
      <el-form>
        <el-form-item label="Invest ID">
          <el-input
            v-model="investId"
            placeholder="Invest ID kiriting"
            @keyup.enter="getInvestData"
          />
        </el-form-item>
      </el-form>
    </div>

    <div v-if="modalStep === 'edit'">
      <el-form
        :model="editForm"
        :rules="rules"
        ref="editFormRef"
        label-width="150px"
        label-position="left"
      >
        <el-form-item label="Nomi" prop="name">
          <el-input v-model="editForm.name" placeholder="Nomini kiriting" />
        </el-form-item>

        <el-form-item label="Buyurtmachi INN" prop="tinOrPinfl">
          <el-input
            v-model="editForm.tinOrPinfl"
            placeholder="Buyurtmachi inn kiritinig"
          />
        </el-form-item>

        <el-form-item label="Hisob raqami" prop="account">
          <el-input
            v-model="editForm.account"
            placeholder="Hisob raqam kiriting"
          />
        </el-form-item>

        <el-form-item label="Ish turi" prop="workTypeId">
          <el-select
            class="form-select"
            v-model="editForm.workTypeId"
            placeholder="Tanlang"
          >
            <el-option
              v-for="type in work_types"
              :value="type.id"
              :key="type.id"
              :label="type.title"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="Qurilish turi" prop="constructionTypeId">
          <el-select
            class="form-select"
            v-model="editForm.constructionTypeId"
            placeholder="Tanlang"
          >
            <el-option
              v-for="type in construction_types_new"
              :value="type.id"
              :key="type.id"
              :label="type.title"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="Status" prop="statusId">
          <el-select
            class="form-select"
            v-model="editForm.statusId"
            placeholder="Tanlang"
          >
            <el-option
              v-for="status in statuses"
              :value="status.id"
              :key="status.id"
              :label="status.name"
            />
          </el-select>
        </el-form-item>
      </el-form>
    </div>

    <template #footer>
      <el-button @click="isModalOpen = false">Bekor qilish</el-button>

      <template v-if="modalStep === 'input'">
        <el-button type="primary" :loading="formLoading" @click="getInvestData">
          Ma'lumotni olish
        </el-button>
      </template>

      <template v-if="modalStep === 'edit'">
        <el-button @click="goBackToInput">Orqaga</el-button>
        <el-button type="primary" :loading="formLoading" @click="saveChanges">
          Saqlash
        </el-button>
      </template>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, reactive } from "vue";
import { ElNotification, ElMessage } from "element-plus";
import http from "@/http";
import { useStore } from "vuex";
import {
  work_types,
  construction_types_new,
} from "@/views/newchronology/ChronologyConstants";
const store = useStore();

const loading = ref(false);
const isModalOpen = ref(false);
const investId = ref("");
const formLoading = ref(false);
const editFormRef = ref(null);
const uploadRef = ref(null);
const modalStep = ref("input");

const uploadExcelUrl = `${process.env.VUE_APP_BASE_API_URL}api/v1/chronology/invest/kazna/open-budget/project-data/bulk-update`;
const uploadHeader = { Authorization: `${store.state.accessToken}` };

// Statuslar ro'yxati (rasmdan olingan)
const statuses = [
  { id: 1, name: "Бошланмаган" },
  { id: 2, name: "Лойиҳачини аниқлаш жараёнида (тендерда)" },
  { id: 3, name: "Лойиҳа-смета ҳужжатларини ишлаб чиқиш жараёнида" },
  { id: 4, name: "Лойиҳа-смета ҳужжатлари давлат экспертизасида" },
  { id: 5, name: "Лойиҳа-смета ҳужжатларига давлат экспертизаси хулосаси берилган" },
  { id: 6, name: "Ҳарид ҳужжатлари экспертизасида (Комплекс)" },
  { id: 7, name: "Ҳарид ҳужжатлари ҳулоса олинган (Комплекс)" },
  { id: 8, name: "Пудратчини аниқлаш жараёнида (тендерда)" },
  { id: 9, name: "Қурилиш жараёнида" },
  { id: 10, name: "Фойдаланишга топширилган" },
  { id: 11, name: "Тўхтатилган (мақбуллаштирилган)" },
  { id: 12, name: "Лойиҳа олди ҳужжатларини тайёрлаш" },
];

const editForm = reactive({
  name: "",
  tinOrPinfl: "",
  account: "",
  workTypeId: "",
  constructionTypeId: "",
  statusId: "",
});

const rules = {
  name: [{ required: false, message: "Nomini kiriting", trigger: "blur" }],
  tinOrPinfl: [
    { required: false, message: "Buyurtmachi inn kiritinig", trigger: "blur" },
  ],
  account: [
    { required: false, message: "Hisob raqam kiriting", trigger: "blur" },
  ],
  workTypeId: [
    { required: false, message: "Ish turini kiriting", trigger: "blur" },
  ],
  statusId: [
    { required: false, message: "Statusni tanlang", trigger: "blur" },
  ],
};

const downloadAllAsExcel = () => {
  loading.value = true;
  http
    .get(`api/v1/chronology/invest/kazna/open-budget/all-projects`, {
      responseType: "blob",
    })
    .then((res) => {
      const url = URL.createObjectURL(
        new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
        })
      );
      const header = res.headers.get("Content-Disposition");
      const parts = header.split(";");
      let fileName = parts[1].split("=")[1];
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    })
    .catch(() => {
      ElNotification({
        title: "Ogohlantirish",
        message: "Ma'lumot yuklashda xatolik sodir bo'ldi!",
        type: "warning",
      });
    })
    .finally(() => {
      loading.value = false;
    });
};

const getInvestData = () => {
  if (!investId.value) {
    ElMessage.warning("Invest ID kiriting");
    return;
  }
  formLoading.value = true;
  http
    .get(
      `api/v1/chronology/invest/kazna/open-budget/project-data/${investId.value}`
    )
    .then((response) => {
      if (Array.isArray(response.data) && response.data.length == 1) {
        editForm.name = response.data[0].name || "";
        editForm.tinOrPinfl = response.data[0].tinOrPinfl || "";
        editForm.account = response.data[0].account || "";
        editForm.workTypeId = response.data[0].workTypeId || "";
        editForm.constructionTypeId = response.data[0].constructionTypeId || "";
        editForm.statusId = response.data[0].statusId || "";
        modalStep.value = "edit";
        console.log("step changing");
      } else {
        throw new Error("Ma'lumot topilmadi");
      }
    })
    .catch((error) => {
      ElNotification({
        title: "Xatolik",
        message: error.response?.data?.message || "Ma'lumotni olishda xatolik",
        type: "error",
      });
    })
    .finally(() => {
      formLoading.value = false;
    });
};

const saveChanges = () => {
  editFormRef.value.validate((valid) => {
    if (!valid) {
      return;
    }

    formLoading.value = true;
    http
      .put(
        `api/v1/chronology/invest/kazna/open-budget/project-data/${investId.value}`,
        editForm
      )
      .then(() => {
        ElNotification({
          title: "Muvaffaqiyat",
          message: "Ma'lumotlar muvafaqiyatli yangilandi",
          type: "success",
        });
        isModalOpen.value = false;
        resetForm();
      })
      .catch((error) => {
        ElNotification({
          title: "Xatolik",
          message:
            error.response?.data?.message || "Ma'lumotlar saqlashda xatolik",
          type: "error",
        });
      })
      .finally(() => {
        formLoading.value = false;
      });
  });
};

const resetForm = () => {
  investId.value = "";
  editForm.name = "";
  editForm.tinOrPinfl = "";
  editForm.account = "";
  editForm.workTypeId = "";
  editForm.constructionTypeId = "";
  editForm.statusId = "";
  modalStep.value = "input";
};

const goBackToInput = () => {
  modalStep.value = "input";
  investId.value = "";
};

const beforeUpload = (file) => {
  // Validate file type
  const allowedTypes = [
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-excel",
  ];

  if (!allowedTypes.includes(file.type)) {
    ElNotification({
      title: "Xatolik",
      message: "Faqat Excel fayllar (.xlsx, .xls) yuklash mumkin",
      type: "error",
    });
    return false;
  }

  // Validate file size (max 10MB)
  const maxSize = 10 * 1024 * 1024; // 10MB
  if (file.size > maxSize) {
    ElNotification({
      title: "Xatolik",
      message: "Fayl hajmi 10MB dan katta bo'lmasligi kerak",
      type: "error",
    });
    return false;
  }

  return true;
};

const onErrorUpload = (error) => {
  loading.value = false;
  ElNotification({
    title: "Xatolik",
    message: error.response?.data?.message || "Ma'lumotlar yuklashda xatolik",
    type: "error",
  });
};

const customUpload = (options) => {
  loading.value = true;

  const formData = new FormData();
  formData.append("file", options.file);

  return http
    .put(uploadExcelUrl, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        ...uploadHeader,
      },
    })
    .then(({ data }) => {
      ElNotification({
        message: `
          <span style="color: #000; font-weight: bold;">Umumiy: ${data.totalRows}</span><br>

           <span style="color: #67C23A; font-weight: bold;">Muvafaqiyatli: ${data.successCount}</span><br> 
           <span style="color: #F56C6C; font-weight: bold;">Muvofaqiyatsiz: ${data.errorCount}</span>
        `,
        type: "success",
        dangerouslyUseHTMLString: true,
      });

      // Reset upload component after successful upload
      if (uploadRef.value) {
        uploadRef.value.clearFiles();
      }
    })
    .catch((error) => {
      ElNotification({
        title: "Xatolik",
        message:
          error.response?.data?.message || "Ma'lumotlar yuklashda xatolik",
        type: "error",
      });

      // Reset upload component after error
      if (uploadRef.value) {
        uploadRef.value.clearFiles();
      }
    })
    .finally(() => {
      loading.value = false;
    });
};
</script>

<style scoped lang="scss">
.wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.upload-demo * {
  margin: 0 !important;
}
</style>